module.exports = __webpack_public_path__ + "img/BO.24408e4f.svg";